/**
 * Product Hero [New] — size/variant, ATC, accordion, reveals
 */
(function () {
  'use strict';

  var SECTION_TYPE = 'product-hero-new';
  var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

  function prefersReduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function reveal(root) {
    var nodes = root.querySelectorAll('[data-ph-reveal]');
    if (!nodes.length) return;

    if (prefersReduced() || typeof IntersectionObserver === 'undefined') {
      nodes.forEach(function (el) {
        el.classList.add('is-inview');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-inview');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '-120px 0px', threshold: 0 }
    );

    nodes.forEach(function (el, i) {
      var delay = el.getAttribute('data-ph-reveal-delay');
      if (delay) el.style.transitionDelay = delay + 'ms';
      io.observe(el);
    });
  }

  function revealIntensity(root) {
    root.querySelectorAll('.vg-intensity-bar').forEach(function (bar) {
      requestAnimationFrame(function () {
        bar.classList.add('is-inview');
      });
    });
  }

  function bindAtc(form) {
    if (!form || form.dataset.vgPhBound) return;
    form.dataset.vgPhBound = '1';

    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      var btn = form.querySelector('[data-add-to-cart]');
      if (btn) btn.classList.add('btn--loading');

      if (window.VGComplimentaryGift && typeof VGComplimentaryGift.syncFormInputs === 'function') {
        VGComplimentaryGift.syncFormInputs(document);
      }

      var data = new FormData(form);
      var addUrl =
        (theme.routes && theme.routes.cartAdd) ||
        (window.routes && window.routes.cart_add_url) ||
        '/cart/add.js';

      fetch(addUrl, {
        method: 'POST',
        body: data,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (payload) {
          if (payload && payload.status === 422) {
            if (btn) btn.classList.remove('btn--loading');
            return null;
          }

          var giftPromise =
            window.VGComplimentaryGift && typeof VGComplimentaryGift.addSelectedGift === 'function'
              ? VGComplimentaryGift.addSelectedGift(form)
              : Promise.resolve(null);

          return giftPromise
            .catch(function () {
              return null;
            })
            .then(function () {
              return payload;
            });
        })
        .then(function (payload) {
          if (btn) btn.classList.remove('btn--loading');
          if (!payload) return;
          if (theme.settings && theme.settings.cartType === 'page') {
            window.location = theme.routes.cartPage || '/cart';
            return;
          }
          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added', {
              detail: { product: payload, addToCartBtn: btn },
            })
          );
        })
        .catch(function () {
          if (btn) btn.classList.remove('btn--loading');
        });
    });
  }

  function bindSizes(root) {
    var sizeBtns = root.querySelectorAll('[data-ph-size]');
    var variantInput = root.querySelector('[data-ph-variant]');
    var priceEl = root.querySelector('[data-ph-price]');
    var atcBtn = root.querySelector('[data-add-to-cart]');

    if (!sizeBtns.length) return;

    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var productUrl = btn.getAttribute('data-product-url');
        if (productUrl) {
          window.location.href = productUrl;
          return;
        }

        sizeBtns.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });

        var variantId = btn.getAttribute('data-variant-id');
        var available = btn.getAttribute('data-available') === 'true';
        var price = btn.getAttribute('data-price');

        if (variantInput && variantId) variantInput.value = variantId;
        if (priceEl && price) priceEl.innerHTML = price;
        if (atcBtn) {
          if (available) atcBtn.removeAttribute('disabled');
          else atcBtn.setAttribute('disabled', 'disabled');
        }
      });
    });
  }

  function bindAccordion(root) {
    var items = root.querySelectorAll('[data-ph-collapsible]');
    if (!items.length) return;

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-ph-collapsible-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var willOpen = !item.classList.contains('is-open');
        items.forEach(function (other) {
          other.classList.remove('is-open');
          var t = other.querySelector('[data-ph-collapsible-trigger]');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
        if (willOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initSection(root) {
    if (!root || root.dataset.vgPhInit) return;
    root.dataset.vgPhInit = '1';

    reveal(root);
    revealIntensity(root);
    bindSizes(root);
    bindAccordion(root);
    bindAtc(root.querySelector('[data-ph-buy-form]'));
  }

  function boot() {
    document.querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var root =
      evt.target &&
      (evt.target.querySelector
        ? evt.target.querySelector('[data-section-type="' + SECTION_TYPE + '"]')
        : null);
    if (!root && evt.target && evt.target.matches) {
      root = evt.target.matches('[data-section-type="' + SECTION_TYPE + '"]') ? evt.target : null;
    }
    if (root) {
      delete root.dataset.vgPhInit;
      initSection(root);
    }
  });
})();
